import { NgModule } from "@angular/core";
import { Route, RouterModule, Routes } from "@angular/router";

export const admin: Routes = [
  {
    path: "utenti",
    loadComponent: () => 
        import('./utenti.component').then((m) => m.UtentiComponent),
  },
];

export const user: Routes = []

@NgModule({
  imports: [RouterModule.forChild(admin)],
  exports: [RouterModule],
})
export class UtentiRoutingModule {
  static routes = admin;
}
